import { AccountService } from './account'
import { BankCardService } from './bankcard'
import { BlacklistService } from './blacklist'
import { CashService } from './cash'
import { ChannelService } from './channel'
import { CreditService } from './credit'
import { LoanService } from './loan'
import { ReceiptService } from './receipt'
import { RepaymentService } from './repayment'
import { RoutingService } from './routing'
import { SubjectService } from './subject'
import { UserService } from './user'
import { ThirdCustomerService } from './third-customer'

class Service {
    thirdCustomerService: ThirdCustomerService
    userService: UserService
    accountService: AccountService
    repaymentService: RepaymentService
    cashService: CashService
    creditService: CreditService
    loanService: LoanService
    subjectService: SubjectService
    blacklistService: BlacklistService
    channelService: ChannelService
    routingService: RoutingService
    bankCardService: BankCardService
    receiptService: ReceiptService
    constructor() {
        this.thirdCustomerService = new ThirdCustomerService()
        this.userService = new UserService()
        this.accountService = new AccountService()
        this.repaymentService = new RepaymentService()
        this.cashService = new CashService()
        this.creditService = new CreditService()
        this.loanService = new LoanService()
        this.subjectService = new SubjectService()
        this.blacklistService = new BlacklistService()
        this.channelService = new ChannelService()
        this.routingService = new RoutingService()
        this.bankCardService = new BankCardService()
        this.receiptService = new ReceiptService()
    }
}

export default new Service()
